import * as React from "react";
import { useContext } from "react";
import { Form } from "semantic-ui-react";
import { ErrorProps, QAPropsBase } from "../State";
import { changeFn, store, validatorFn, handleAnswerUpdate } from "../store";

// tslint:disable-next-line: interface-name
interface Props {
    index: number;
    propsBase: QAPropsBase;
    onChange?: changeFn;
}

const TextAreaAnswer: React.FunctionComponent<Props> = (props: Props) => {
  const globalState = useContext(store);
  const { dispatch } = globalState;

  return (
      <Form.TextArea required id={props.index} rows={4} className="textarea-answer"
          // tslint:disable-next-line: max-line-length
            onChange={(e, d) => handleAnswerUpdate(d.value as string, props.propsBase.answerValidator as validatorFn, props.index, dispatch, globalState.state.appState.optionChosen)}
            error={props.propsBase.isAnswered && !props.propsBase.isAnswerValid && props.propsBase.errorProps}>
      </Form.TextArea >
    );
  };

export default TextAreaAnswer;
